export interface PromoInfoShort {
    PromoStatus:                      PromoStatusEnum;
    PromoKind:                        PromoKindEnum;
    PromoID:                          string;
    PromoDefGroupingIDs:              string[];
    StartDate:                        Date;
    EndDate:                          Date;
    HaveCurrentPresale:               boolean;
    PromoSuggestionPageURL:           string;
    PromoSuggestionLinkText:          string;
    PromoSuggestionPasswordProtected: boolean;
    PromoImportantInfo:               string;
    PresaleSpecialMessage:            null | string;
}

export enum PromoStatusEnum {
    NoPromo = 0,
    PromoAvailable = 1,
    InPromo = 2,
    FellOutOfPromo = 3,
    PromoNotYetStarted = 4,
    PasswordNeeded = 5
}

export enum PromoKindEnum {
    NoPresale = 0,
    PresaleSystem = 1,
    PromoCodeSystem = 2
}
